module.exports = __webpack_public_path__ + "static/media/metervibe_app_desktop_2.95ee9b2a.png";